import { MOOD_START, OUTAGE_START_MINUTE, RESTORE_MINUTE } from './constants';
import { batteryCapacityEu } from './gameReducer';
import { DifficultyTier, GameState, Score } from './types';

const OFFGRID_MASTER_HOURS = 24;

/** winning poor earns a bonus — a skilled Shoestring run can out-title a lazy Comfortable one */
const TIER_MULTIPLIER: Record<DifficultyTier['id'], number> = { comfortable: 1, shoestring: 1.25, tight: 1.1 };

const TITLES: [minScore: number, title: string][] = [
  [85, 'Grid-Independence Guru'],
  [65, 'Backup Boss'],
  [40, 'Outage Survivor'],
  [0, 'Crispy but Alive'],
];

export const computeScore = (state: GameState): Score => {
  const capacity = batteryCapacityEu(state.prep);
  const avgMood = state.moodSamples > 0 ? state.moodSum / state.moodSamples : MOOD_START;
  const batteryNeverEmpty = state.blackoutMinutes === 0;
  const endingBatteryPct = capacity > 0 ? state.batteryEu / capacity : 0;
  const outageMinutes = RESTORE_MINUTE - OUTAGE_START_MINUTE + state.overtimeMinutes;
  const comfortPct = Math.min(1, state.comfortMinutes / outageMinutes);
  const overtimeHours = Math.floor(state.overtimeMinutes / 60);

  const tierMultiplier = TIER_MULTIPLIER[state.prep.difficultyId];
  const base = 0.45 * avgMood + (batteryNeverEmpty ? 25 : 0) + 15 * comfortPct + 15 * endingBatteryPct;
  const total = Math.round(Math.min(100, Math.max(0, base * tierMultiplier)));

  const earnedTitle = TITLES.find(([minScore]) => total >= minScore)?.[1] ?? TITLES[TITLES.length - 1][1];
  const title = overtimeHours >= OFFGRID_MASTER_HOURS ? 'Offgrid Master' : earnedTitle;

  return { avgMood, batteryNeverEmpty, comfortPct, endingBatteryPct, overtimeHours, tierMultiplier, title, total };
};
